module.exports = __webpack_public_path__ + "img/home_02.8fc51c3e.png";